import * as React from "react";
import { CircularProgress, IconButton, Tooltip, Typography, Stack } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useTokens } from "../theme";

export function formatAge(updatedAt, now = Date.now()) {
  if (!updatedAt) return "";
  const seconds = Math.max(0, Math.round((now - updatedAt) / 1000));
  if (seconds < 10) return "just now";
  if (seconds < 60) return `${seconds}s ago`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  return `${Math.floor(minutes / 60)}h ago`;
}

// "Updated 2m ago" plus a refresh button, so it's clear the table is current.
export default function RefreshStatus({ updatedAt, isFetching, onRefresh }) {
  const tokens = useTokens();
  const [now, setNow] = React.useState(Date.now());

  React.useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), 15000);
    return () => clearInterval(timer);
  }, []);

  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <Typography sx={{ fontSize: "12px", color: tokens.mutedForeground }} aria-live="off">
        {updatedAt ? `Updated ${formatAge(updatedAt, now)}` : ""}
      </Typography>
      <Tooltip title="Refresh">
        <span>
          <IconButton size="small" aria-label="Refresh" onClick={onRefresh} disabled={isFetching}>
            {isFetching ? <CircularProgress size={16} /> : <RefreshIcon fontSize="small" />}
          </IconButton>
        </span>
      </Tooltip>
    </Stack>
  );
}
